import { JSX } from "react";
import { Breadcrumbs } from "@hatch-digital-nl/bravilor-storybook";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { ProductTypeEnum } from "../../../common/enums/ProductTypeEnum";
import { LanguageInterface } from "../../../common/interfaces/shared/LanguageInterface";
import { ProductDetailInterface } from "../../../common/interfaces/apiV2/product/ProductDetailInterface";
import { useAppDispatch } from "../../../app/hooks";
import { setProductType } from "../../productRangePage/ProductRangeSlice";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

interface Props {
    data: ProductDetailInterface | undefined;
    isPageLoading: boolean;
    activeLanguage: LanguageInterface | null;
}

export const ProductDetailsHeader = ({
    data,
    isPageLoading,
    activeLanguage,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch();
    const { t } = useStringTranslation();

    if (isPageLoading || !data || !activeLanguage) {
        return (
            <div className="c-breadcrumbs">
                <Breadcrumbs isLoading items={[]} />
            </div>
        );
    }

    return (
        <div className="c-breadcrumbs">
            <Breadcrumbs
                items={[
                    {
                        label: t("product-range"),
                        to: RouteEnum.PRODUCT_RANGE,
                    },
                    {
                        label:
                            data.productFamily?.code === "accessories"
                                ? t("accessories")
                                : t("machines"),
                        to: RouteEnum.PRODUCT_RANGE,
                        onClick: () =>
                            dispatch(
                                setProductType(
                                    data.productFamily?.code === "accessories"
                                        ? ProductTypeEnum.accessories
                                        : ProductTypeEnum.products,
                                ),
                            ),
                    },
                    {
                        label: data.label,
                    },
                ]}
            />
        </div>
    );
};
